export const PRODUCT_FINDER_SEGMENT = 'catalog';
export const SUBSCRIPTION_CHECKOUT_SEGMENT = 'account/subscription/checkout';

const productFinder = {
  path: `/:language/${PRODUCT_FINDER_SEGMENT}/:url(.*)*`,
  name: 'product-finder',
};

export const productFinderRoutes = {
  productFinder,
};

export const SUBSCRIPTION_CHECKOUT_PATHS = {
  account: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/account/`,
  address: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/address/`,
  payment: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/payment/`,
  successSurvey: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/success/survey`,
  successDownload: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/success/download`,
  review: `/:language/${SUBSCRIPTION_CHECKOUT_SEGMENT}/review/:subscriptionId?/:planId?`,
};
